<template>
  <div id="app">
    <menu-side v-if="window.location.href.includes('what-we-do')"></menu-side>
    <vue-page-transition>
      <router-view/>
    </vue-page-transition>
  </div>
<!--  <GreenIQ></GreenIQ>-->
<!--<Menu></Menu>-->
</template>

<script>
//import MenuSide from '../components/MenuSide'
import GreenIQ from './CustomersComponents/CustomerMain'
import Menu from '../pages/Menu'

import MenuSide from '@bit/hippotec.website2019.menu-side';

export default {
  name: 'App',
  data(){
    return {
      window
    }
  },
  components: {
    MenuSide: MenuSide,
    GreenIQ: GreenIQ,
    Menu: Menu

  }
}
</script>

<style lang="scss">
  @import "../assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/pages/App.vue